var PururinComment = {
    init: function () {
        var self = this;
        (function () {
            var match = window.location.hash.match(/#(C|M)(\d+)/);
            var id = match ? match[2] : null;
            self.selectComment(id);
        })();
        $('.comment-edit').on('click', function (e) {
            e.preventDefault();
            self.toggleEdit(this);
        });
        $('button[role="cancel"]').on('click', function (e) {
            e.preventDefault();
            self.toggleEdit(this);
        });
        $('#comment-show-hidden').on('click', function (e) {
            e.preventDefault();
            $('.comment.comment-hidden').each(function (e) {
                $(this).removeClass('comment-hidden');
                $(this).addClass('bad');
            });
        });
        $('#comment-preview-btn').on('click', function (e) {
            self.startLoading($(this));
            var loader = $('#comment-preview div');
            var cmdText = $('#comment-textarea').val();

            if (cmdText.length <= 0) {
                PururinMessage.error('You should probably type something first!')
                self.stopLoading($(this));
                return
            }
            if (cmdText.length < 3) {
                PururinMessage.error('That doesn\'t look very witty. Bash that keyboard some more.')
                self.stopLoading($(this));
                return
            }
            axios.post('/comment/preview', {
                comment: cmdText,
            }).then((resp) => {
                $('#comment-preview').collapse('show');
                loader.html(resp.data);
                self.stopLoading($(this));
            }).catch(e => {
                PururinMessage.error(e.response.data.msg || e.response.data.message || e.message);
                self.stopLoading($(this));
            })
        });
        $('.comment-select').on('click', function (e) {
            var id = $(this).data('id');
            self.selectComment(id);
        });
        $('.comment-reply').on('click', function (e) {
            e.preventDefault();
            var id = $(this).data('id');
            self.appendToPost(`[C${id}]`);
        });
        $('.comment-post').on('submit', function (e) {
            var btn = $(e.target).find(':focus');
            self.startLoading(btn);
            var cmdText = $('#comment-textarea').val();
            if (cmdText.length <= 0) {
                PururinMessage.error('You should probably type something first!')
                self.stopLoading(btn);
                e.preventDefault();
                return
            }
            if (cmdText.length < 3) {
                PururinMessage.error('That doesn\'t look very witty. Bash that keyboard some more.')
                self.stopLoading(btn);
                e.preventDefault();
                return
            }
        });
        $('#comment-search-toggle').on('click', function (e) {
            e.preventDefault();
            $('#comment-search').animate({
                width: 'toggle'
            });
            return false;
        });
        $('#comment-search').autocomplete({
            source: '/comment/search',
            delay: 500,
            minLength: 2,
            select: function (e, ui) {
                self.appendToPost(ui.item.value);
                $(this).val('')
                return false;
            }
        })
        $('.vote a').on('click', function (e) {
            e.preventDefault();
            var target = $(this);
            var id = target.parent().data('id');
            var type = target.data('type');
            self.startLoading(target);
            axios.post(`/comment/vote/${id}/${type}`).then((resp) => {
                self.stopLoading(target)
                target.addClass('active');
                target.siblings('a').removeClass('active');
                var counter = target.parent().find('div');
                if (resp.data.count > 0) {
                    counter.addClass('text-success');
                    counter.removeClass('text-danger');
                } else if (resp.data.count < 0) {
                    counter.addClass('text-danger');
                    counter.removeClass('text-success');
                } else {
                    counter.removeClass('text-success');
                    counter.removeClass('text-danger');
                }
                counter.text(resp.data.count)
            }).catch(e => {
                PururinMessage.error(e.response.data.msg || e.response.data.message || e.message);
            });
        });
    },
    appendToPost: function (str) {
        var cmdText = $('#comment-textarea');
        cmdText.focus();
        cmdText.val(cmdText.val() + str + '\n');
    },
    toggleEdit: function (_this) {
        var id = $(_this).data('id');
        var commentText = $(`#comment-text-${id}`);
        var span = commentText.find('span');
        span.toggleClass('d-none');
        var form = commentText.find('form');
        form.toggleClass('d-none');
    },
    startLoading: function (e) {
        e.toggleClass('is-loading');
        e.attr('disabled', 'dsiabled');
    },
    stopLoading: function (e) {
        e.toggleClass('is-loading');
        e.removeAttr('disabled');
    },
    selectComment: function (id) {
        if (!id) return;
        $(`#M${id}`).addClass('selected');
        $(`#M${id}`).siblings('div').removeClass('selected');
        $(`#C${id}`).addClass('selected');
        $(`#C${id}`).siblings('div').removeClass('selected');
    },
}
$(function () {
    PururinComment.init();
});
